// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.home-page-container .section-wrapper {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;
  will-change: transform, opacity;
}
.home-page-container .section-wrapper.animate {
  opacity: 1;
  transform: translateY(0);
}
.home-page-container .h3-heading {
  font-family: "Alice", serif;
  font-weight: 400;
  font-style: normal;
  font-size: 70px;
}
@media screen and (max-width: 576px) {
  .home-page-container .h3-heading {
    font-size: 35px;
  }
}
.home-page-container .hotspot-button {
  width: 20px;
  height: 20px;
  transform: translate(-50%, -50%);
  border: 2px solid white;
  cursor: pointer;
}
.home-page-container .home-page-carousel-container {
  padding-top: 40px;
  padding-bottom: 40px;
}
.home-page-container .home-page-carousel-container h1 {
  font-size: 80px;
  font-family: "SF  Pro", sans-serif;
  font-weight: bold;
  font-style: normal;
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: fadeInDown 0.8s ease-out;
}
.home-page-container .home-page-carousel-container .banner-tagline-box {
  max-width: 950px;
  background: linear-gradient(135deg, rgba(178, 32, 32, 0.95) 0%, rgba(255, 117, 117, 0.9) 100%);
  border-radius: 20px;
  padding: 35px 45px;
  box-shadow: 0 10px 40px rgba(178, 32, 32, 0.3);
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.9s ease-out;
  transition: all 0.4s ease;
}
.home-page-container .home-page-carousel-container .banner-tagline-box::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotate 20s linear infinite;
}
.home-page-container .home-page-carousel-container .banner-tagline-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(178, 32, 32, 0.4);
}
.home-page-container .home-page-carousel-container .banner-tagline-box .tagline-content {
  position: relative;
  z-index: 1;
}
.home-page-container .home-page-carousel-container .banner-tagline-box .tagline-main {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.4;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.home-page-container .home-page-carousel-container .banner-tagline-box .tagline-sub {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
  font-weight: 500;
  line-height: 1.6;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.home-page-container .home-page-carousel-container .heading-mobile {
  display: none;
}
.home-page-container .home-page-carousel-container .heading-mobile .banner-tagline-box {
  padding: 25px 30px;
}
.home-page-container .home-page-carousel-container .heading-mobile .banner-tagline-box .tagline-main {
  font-size: 1.25rem;
}
.home-page-container .home-page-carousel-container .heading-mobile .banner-tagline-box .tagline-sub {
  font-size: 0.95rem;
}
@media screen and (max-width: 576px) {
  .home-page-container .home-page-carousel-container h1 {
    font-size: 40px;
  }
  .home-page-container .home-page-carousel-container .heading-mobile {
    display: block;
  }
  .home-page-container .home-page-carousel-container .heading {
    display: none;
  }
}
.home-page-container .home-page-carousel-container .swiper {
  width: 100%;
}
.home-page-container .home-page-carousel-container .swiper img {
  max-width: 1400px;
  max-height: 650px;
  border-radius: 15px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}
.home-page-container .home-page-carousel-container .swiper img:hover {
  transform: scale(1.02);
}
.home-page-container .home-page-wrapper {
  width: 100%;
}
.home-page-container .home-page-wrapper .text-container {
  max-width: 798px;
  margin: auto;
  margin-top: 62px;
}
.home-page-container .home-page-wrapper .text-container p {
  color: #212121;
  font-family: "SF  Pro", sans-serif;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 37px;
  max-width: 604px;
}
.home-page-container .home-page-wrapper .text-container span {
  margin-top: 35px;
  color: #757575;
  font-family: "SF  Pro", sans-serif;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 30px;
}
@media screen and (min-width: 576px) {
  .home-page-container .home-page-wrapper .card-section {
    margin-top: 100px;
  }
}
.home-page-container .home-page-wrapper .card-section {
  width: 100%;
}
.home-page-container .home-page-wrapper .card-section.our-services-section {
  scroll-margin-top: 80px;
}
@media screen and (min-width: 576px) {
  .home-page-container .home-page-wrapper .card-section.our-services-section {
    padding-bottom: 200px !important;
  }
}
.home-page-container .home-page-wrapper .card-section.our-services-section {
  padding-bottom: 250px;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .our-services-section-bg {
  max-width: 1160px;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section {
  background: linear-gradient(135deg, #b22020 0%, #d63636 50%, #ff7575 100%);
  position: relative;
  overflow: hidden;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotateBackground 25s linear infinite;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section .container {
  padding-bottom: 200px;
  animation: fadeIn 0.8s ease-in;
  position: relative;
  z-index: 1;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section h3 {
  text-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section p {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section img {
  clip-path: polygon(60px 0%, 100% 0%, 100% 100%, 0% 100%);
  height: 230px;
  transition: all 0.4s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section img:hover {
  transform: scale(1.03) translateX(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 576px) {
  .home-page-container .home-page-wrapper .card-section.our-services-section .services-text-section img {
    display: none;
  }
}
@keyframes rotateBackground {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.home-page-container .home-page-wrapper .card-section.our-services-section .services-cards-section {
  transform: translateY(-50%);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .swiper {
  padding-bottom: 80px;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .navigation {
  right: 40px;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card {
  border: none;
  border-radius: 15px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0px 15px 40px rgba(178, 32, 32, 0.25);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card:hover::before {
  transform: scaleX(1);
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card .card-body {
  padding: 20px;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card .card-body h4 {
  font-weight: 600;
  color: #212121;
  margin-top: 16px;
  font-size: 1.25rem;
  line-height: 1.4;
  transition: color 0.3s ease;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card:hover .card-body h4 {
  color: #b22020;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card .card-footer {
  padding: 0 27px 26px 27px;
  background: transparent;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card .service-img {
  transition: all 0.4s ease;
  border-radius: 10px 10px 0 0;
}
.home-page-container .home-page-wrapper .card-section.our-services-section .card:hover .service-img {
  transform: scale(1.08);
  filter: brightness(1.05);
}

.swiper-pagination {
  width: max-content;
}
.swiper-pagination .swiper-pagination-bullet {
  background-color: var(--grey);
  width: 5px;
  height: 5px;
  transition: all 0.3s;
}
.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 30px;
  background-color: black;
  border-radius: 10px;
}

@media screen and (min-width: 768px) {
  section.easy-support-container .container {
    padding: 50px 0 0 64px;
  }
}
section.easy-support-container .container {
  border-radius: 25px;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #fdf8f0 0%, #fff5e6 100%);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}
section.easy-support-container .container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(178, 32, 32, 0.03) 0%, rgba(255, 117, 117, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}
section.easy-support-container .container:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 35px rgba(178, 32, 32, 0.15);
}
section.easy-support-container .container:hover::before {
  opacity: 1;
}
section.easy-support-container .container h3 {
  position: relative;
  z-index: 1;
}
section.easy-support-container .container p {
  position: relative;
  z-index: 1;
}
section.easy-support-container .container .easy-support-banner {
  border-bottom-right-radius: 25px;
  transition: all 0.4s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}
section.easy-support-container .container:hover .easy-support-banner {
  transform: scale(1.03) rotate(1deg);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

section.our-stories {
  background: linear-gradient(180deg, #ffffff 0%, #fdf8f0 100%);
  position: relative;
}
section.our-stories .stories-header-box {
  max-width: 800px;
  animation: fadeInDown 0.8s ease-out;
}
section.our-stories .stories-header-box h2 {
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
section.our-stories .stories-header-box .stories-subtitle {
  font-size: 1.25rem;
  color: #434343;
  font-weight: 500;
  line-height: 1.6;
}
section.our-stories .navigation {
  justify-content: end;
}
section.our-stories .stories-wrapper .story-img {
  height: 450px;
  object-fit: cover;
  border-radius: 20px;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
section.our-stories .stories-wrapper .img-flash-card-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 1;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 60px rgba(178, 32, 32, 0.3);
}
section.our-stories .stories-wrapper .img-flash-card-wrapper:hover::before {
  opacity: 1;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper:hover .story-img {
  transform: scale(1.1);
}
section.our-stories .stories-wrapper .img-flash-card-wrapper:hover .story-overlay {
  opacity: 0.8;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper:hover .story-content {
  transform: translateY(0);
  opacity: 1;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.9) 100%);
  opacity: 0.6;
  transition: opacity 0.4s ease;
  z-index: 2;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content {
  padding: 30px;
  z-index: 3;
  transform: translateY(20px);
  opacity: 0.9;
  transition: all 0.4s ease;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-gradient-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(180deg, transparent 0%, rgba(178, 32, 32, 0.8) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content.hovered .story-gradient-bg {
  opacity: 1;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-city-name {
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 0 3px 15px rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
  animation: slideInLeft 0.6s ease-out;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-description {
  font-size: 1.125rem;
  line-height: 1.6;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  animation: slideInLeft 0.7s ease-out;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-explore-btn {
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  padding: 14px 32px;
  font-size: 1.125rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(178, 32, 32, 0.4);
  cursor: pointer;
  width: fit-content;
  animation: slideInLeft 0.8s ease-out;
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-explore-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 8px 30px rgba(178, 32, 32, 0.6);
  border-color: rgba(255, 255, 255, 0.6);
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-explore-btn:hover svg {
  transform: translateX(5px);
}
section.our-stories .stories-wrapper .img-flash-card-wrapper .story-content .story-explore-btn svg {
  transition: transform 0.3s ease;
}
section.our-stories .stories-wrapper .swiper {
  padding-bottom: 80px;
  overflow: visible;
}
section.our-stories .stories-wrapper .swiper-slide {
  transition: all 0.4s ease;
  opacity: 0.85;
  transform: scale(0.95);
}
section.our-stories .stories-wrapper .swiper-slide.swiper-slide-active {
  opacity: 1;
  transform: scale(1);
  z-index: 2;
}
section.our-stories .stories-wrapper .swiper-slide.swiper-slide-prev, section.our-stories .stories-wrapper .swiper-slide.swiper-slide-next {
  opacity: 0.7;
  transform: scale(0.92);
}
section.our-stories .stories-wrapper .swiper-pagination {
  width: max-content;
  margin-left: 50%;
  transform: translateX(-50%);
}
section.our-stories .stories-wrapper .swiper-pagination .swiper-pagination-bullet {
  background: #b22020;
  width: 12px;
  height: 12px;
  opacity: 0.5;
  transition: all 0.3s ease;
}
section.our-stories .stories-wrapper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  width: 30px;
  border-radius: 10px;
}
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
section.our-stories .container div {
  gap: 20px;
  width: 100%;
}
section.our-stories .container div span {
  font-size: 1.25rem;
  font-weight: 700;
}

section.testimonial {
  background: linear-gradient(180deg, #fdf8f0 0%, #ffffff 100%);
  position: relative;
}
section.testimonial .testimonial-header-box {
  max-width: 800px;
  animation: fadeInDown 0.8s ease-out;
}
section.testimonial .testimonial-header-box h2 {
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 3rem;
}
section.testimonial .testimonial-header-box .testimonial-subheading {
  font-size: 2rem;
  color: #434343;
  font-weight: 600;
}
section.testimonial .testimonial-header-box .testimonial-subtitle {
  font-size: 1.25rem;
  color: #434343;
  font-weight: 500;
  line-height: 1.6;
}
section.testimonial .testimonials-wrapper {
  gap: 80px;
}
section.testimonial .swiper-wrapper {
  padding-bottom: 60px;
}
section.testimonial .swiper-slide {
  min-height: 100%;
  height: auto;
  transition: all 0.4s ease;
}
section.testimonial .swiper-slide:hover {
  transform: translateY(-5px);
}
section.testimonial .swiper-slide .testimonial-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  border: none;
  overflow: hidden;
  position: relative;
  transition: box-shadow 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
section.testimonial .swiper-slide .testimonial-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);
  border-radius: 20px 20px 0 0;
}
section.testimonial .swiper-slide .testimonial-card:hover {
  box-shadow: 0 15px 50px rgba(178, 32, 32, 0.2);
  transform: translateY(-6px);
}
section.testimonial .swiper-slide .testimonial-card.testimonial-card--fixed {
  width: 100%;
  max-width: 400px;
  height: 420px;
  margin-left: auto;
  margin-right: auto;
}
section.testimonial .swiper-slide .testimonial-card .quote-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: rgba(178, 32, 32, 0.15);
  z-index: 1;
  animation: float 3s ease-in-out infinite;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-card-body.card-body {
  padding: 30px;
  position: relative;
  z-index: 2;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  text-align: center;
  align-items: center;
}
section.testimonial .swiper-slide .testimonial-card .customer-name-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-shrink: 0;
  margin-bottom: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);
  border-radius: 50px;
  width: fit-content;
  max-width: 100%;
}
section.testimonial .swiper-slide .testimonial-card .customer-name-badge .customer-icon {
  font-size: 1.5rem;
}
section.testimonial .swiper-slide .testimonial-card .customer-name-badge .card-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #212121;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-scroll-region {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 4px;
  margin-right: -4px;
  text-align: center;
  scrollbar-width: thin;
  scrollbar-color: rgba(178, 32, 32, 0.45) transparent;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-scroll-region::-webkit-scrollbar {
  width: 6px;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-scroll-region::-webkit-scrollbar-thumb {
  background: rgba(178, 32, 32, 0.35);
  border-radius: 6px;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-content {
  font-size: 1rem;
  line-height: 1.8;
  color: #434343;
  text-align: center;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-content--html {
  text-align: center;
}
section.testimonial .swiper-slide .testimonial-card .testimonial-content--html ol,
section.testimonial .swiper-slide .testimonial-card .testimonial-content--html ul {
  display: inline-block;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
section.testimonial .line {
  background-color: var(--grey-light);
  height: 2px;
  width: 80%;
  margin-top: 30px;
}
section.testimonial .adjusted-margin {
  margin-top: -1rem;
}

section.gst-details-section {
  padding: 80px 40px;
  background: linear-gradient(180deg, #ffffff 0%, #fdf8f0 50%, #ffffff 100%);
  position: relative;
}
section.gst-details-section .gst-header-box {
  max-width: 900px;
  animation: fadeInDown 0.8s ease-out;
}
section.gst-details-section .gst-header-box h2 {
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
section.gst-details-section .gst-header-box .gst-subtitle {
  font-size: 1.25rem;
  color: #434343;
  font-weight: 500;
  line-height: 1.6;
}
section.gst-details-section h2,
section.gst-details-section .map-hotspots {
  margin-bottom: 40px;
}
@media screen and (min-width: 992px) {
  section.gst-details-section h2,
  section.gst-details-section .map-hotspots {
    margin-bottom: 80px;
  }
}
@media screen and (max-width: 768px) {
  section.gst-details-section {
    padding: 40px 0 !important;
  }
}
section.gst-details-section .map-hotspots {
  min-width: 620px;
  max-width: 620px;
  height: 720px;
  position: relative;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.1));
  transition: all 0.4s ease;
}
section.gst-details-section .map-hotspots:hover {
  filter: drop-shadow(0 15px 40px rgba(178, 32, 32, 0.2));
}
section.gst-details-section .map-hotspots path {
  transition: all 0.3s ease;
}
section.gst-details-section .map-hotspots img {
  background-size: contain;
  background-repeat: no-repeat;
}
section.gst-details-section .map-hotspots .state {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);
  border: 4px solid rgba(255, 255, 255, 0.9);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  outline: 2px solid rgba(178, 32, 32, 0.3);
  box-sizing: content-box;
  cursor: pointer;
  animation: pulse 2s ease-in-out infinite;
}
section.gst-details-section .map-hotspots .state:hover {
  transform: scale(2);
  z-index: 10;
  background: linear-gradient(135deg, #ff7575 0%, #b22020 100%);
  box-shadow: 0 0 20px rgba(178, 32, 32, 0.6);
  animation: none;
}
section.gst-details-section .map-hotspots .state.selected {
  transform: scale(2);
  z-index: 10;
  background: linear-gradient(135deg, #ff7575 0%, #b22020 100%);
  box-shadow: 0 0 25px rgba(178, 32, 32, 0.8);
  animation: selectedPulse 1.5s ease-in-out infinite;
}
section.gst-details-section .map-hotspots .state.Goa {
  left: 128px;
  top: 540px;
}
section.gst-details-section .map-hotspots .state.Uttar.Pradesh {
  left: 270px;
  top: 280px;
}
section.gst-details-section .map-hotspots .state.Haryana {
  left: 188px;
  top: 230px;
}
section.gst-details-section .map-hotspots .state.Karnataka {
  left: 170px;
  top: 560px;
}
section.gst-details-section .map-hotspots .state.Maharashtra {
  left: 170px;
  top: 450px;
}
section.gst-details-section .map-hotspots .state.Telangana {
  left: 244px;
  top: 482px;
}
section.gst-details-section .map-hotspots .state.Bihar {
  left: 380px;
  top: 305px;
}
section.gst-details-section .map-hotspots .state.Gujarat {
  left: 80px;
  top: 370px;
}
section.gst-details-section .map-hotspots .state.Kerala {
  left: 180px;
  top: 644px;
}
section.gst-details-section .map-hotspots .state.Himachal.Pradesh {
  left: 205px;
  top: 165px;
}
section.gst-details-section .map-hotspots .state.Tamil.Nadu {
  left: 229px;
  top: 634px;
}
section.gst-details-section .map-hotspots .state.Jharkhand {
  left: 364px;
  top: 353px;
}
section.gst-details-section .map-hotspots .state.Rajasthan {
  left: 130px;
  top: 285px;
}
section.gst-details-section .map-hotspots .state.Madhya.Pradesh {
  left: 230px;
  top: 365px;
}
section.gst-details-section .map-hotspots .state.Odisha {
  left: 360px;
  top: 420px;
}
section.gst-details-section .map-hotspots .state.Chandigarh {
  left: 183px;
  top: 200px;
}
section.gst-details-section .accordion-item {
  border-radius: 30px;
  border: 1px solid transparent;
}
section.gst-details-section .accordion-item:has(.accordion-collapse.show) {
  border: 1px solid var(--grey);
}
section.gst-details-section .accordion-item:has(.accordion-collapse.show) .accordion-button,
section.gst-details-section .accordion-item:has(.accordion-collapse.show) .accordion-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
section.gst-details-section .accordion-item .accordion-header,
section.gst-details-section .accordion-item .accordion-button {
  border-radius: 30px;
  background: var(--primary-yellow);
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}
@keyframes selectedPulse {
  0%, 100% {
    box-shadow: 0 0 25px rgba(178, 32, 32, 0.8);
  }
  50% {
    box-shadow: 0 0 35px rgb(178, 32, 32);
  }
}
section.gst-details-section .state-data-container {
  background: linear-gradient(135deg, #ffffff 0%, #fdf8f0 100%);
  border-radius: 25px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  min-width: 400px;
  width: max-content;
  height: max-content;
  position: relative;
  overflow: hidden;
  transition: all 0.5s ease;
}
section.gst-details-section .state-data-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);
  border-radius: 25px 25px 0 0;
}
section.gst-details-section .state-data-container:hover {
  box-shadow: 0 15px 50px rgba(178, 32, 32, 0.2);
  transform: translateY(-5px);
}
section.gst-details-section .state-data-container .state-badge {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  padding: 15px 25px;
  background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);
  border-radius: 50px;
  width: fit-content;
}
section.gst-details-section .state-data-container .state-badge .location-icon {
  font-size: 2rem;
}
section.gst-details-section .state-data-container .state-badge .state-name {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #212121;
}
section.gst-details-section .state-data-container .gst-info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 15px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
section.gst-details-section .state-data-container .gst-info-item:last-child {
  border-bottom: none;
}
section.gst-details-section .state-data-container .gst-info-item:hover {
  padding-left: 10px;
  background: rgba(178, 32, 32, 0.05);
  border-radius: 10px;
}
section.gst-details-section .state-data-container .gst-info-item .info-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #b22020;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
section.gst-details-section .state-data-container .gst-info-item .info-value {
  font-size: 1.125rem;
  font-weight: 500;
  color: #212121;
  line-height: 1.6;
}
section.gst-details-section .state-data-container.op-anim {
  opacity: 0;
  transform: translateX(-20px);
}
section.gst-details-section .state-data-container.op-anim p,
section.gst-details-section .state-data-container.op-anim h3 {
  opacity: 0;
}

section.home-page-content-section {
  padding: 60px 80px;
}
@media screen and (max-width: 768px) {
  section.home-page-content-section {
    padding: 30px 15px;
  }
}
section.home-page-content-section .font-medium {
  font-size: 1.5rem;
}
section.home-page-content-section .font-bold {
  font-size: 2.25rem;
}

section.brand-carousel {
  white-space: nowrap;
  padding: 40px 0 80px 0;
}
section.brand-carousel .carousel-track {
  gap: 40px;
  animation: scroll 15s linear infinite;
  width: fit-content;
}
section.brand-carousel .brand-logo {
  height: 70px;
  width: auto;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAEE;EACE,UAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;AAAJ;AAEI;EACE,UAAA;EACA,wBAAA;AAAN;AAIE;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAII;EANF;IAOI,eAAA;EADJ;AACF;AAIE;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;AAFJ;AAKE;EACE,iBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,eAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,mCAAA;AAHN;AAMI;EACE,gBAAA;EACA,8FAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;AAJN;AAMM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,qCAAA;AAJR;AAOM;EACE,2BAAA;EACA,8CAAA;AALR;AAQM;EACE,kBAAA;EACA,UAAA;AANR;AASM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAPR;AAUM;EACE,mBAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AARR;AAYI;EACE;IACE,UAAA;IACA,4BAAA;EAVN;EAYI;IACE,UAAA;IACA,wBAAA;EAVN;AACF;AAaI;EACE;IACE,UAAA;IACA,2BAAA;EAXN;EAaI;IACE,UAAA;IACA,wBAAA;EAXN;AACF;AAcI;EACE;IACE,uBAAA;EAZN;EAcI;IACE,yBAAA;EAZN;AACF;AAeI;EACE,aAAA;AAbN;AAeM;EACE,kBAAA;AAbR;AAeQ;EACE,kBAAA;AAbV;AAgBQ;EACE,kBAAA;AAdV;AAmBI;EACE;IACE,eAAA;EAjBN;EAoBI;IACE,cAAA;EAlBN;EAqBI;IACE,aAAA;EAnBN;AACF;AAsBI;EACE,WAAA;AApBN;AAsBM;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,+BAAA;AApBR;AAsBQ;EACE,sBAAA;AApBV;AA0BE;EACE,WAAA;AAxBJ;AA0BI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,cAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAxBR;AA2BM;EACE,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAzBR;AA8BM;EADF;IAEI,iBAAA;EA3BN;AACF;AAwBI;EAIE,WAAA;AAzBN;AA2BM;EAEE,uBAAA;AA1BR;AA4BQ;EAJF;IAKI,gCAAA;EAzBR;AACF;AAmBM;EAOE,qBAAA;AAvBR;AAwBQ;EACE,iBAAA;AAtBV;AAyBQ;EACE,0EAAA;EACA,kBAAA;EACA,gBAAA;AAvBV;AAyBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,+CAAA;AAvBZ;AA0BU;EACE,qBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AAxBZ;AA2BU;EACE,0CAAA;AAzBZ;AA4BU;EACE,2CAAA;AA1BZ;AA6BU;EACE,wDAAA;EACA,aAAA;EACA,yBAAA;EACA,yCAAA;AA3BZ;AA6BY;EACE,uCAAA;EACA,yCAAA;AA3Bd;AA+BU;EACE;IACE,aAAA;EA7BZ;AACF;AAiCQ;EACE;IACE,uBAAA;EA/BV;EAiCQ;IACE,yBAAA;EA/BV;AACF;AAkCQ;EACE;IACE,UAAA;IACA,2BAAA;EAhCV;EAkCQ;IACE,UAAA;IACA,wBAAA;EAhCV;AACF;AAmCQ;EACE,2BAAA;AAjCV;AAoCQ;EACE,oBAAA;AAlCV;AAqCQ;EACE,WAAA;AAnCV;AAsCQ;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,4DAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApCV;AAsCU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,oBAAA;EACA,+BAAA;AApCZ;AAuCU;EACE,wCAAA;EACA,iDAAA;AArCZ;AAuCY;EACE,oBAAA;AArCd;AAyCU;EACE,aAAA;AAvCZ;AAyCY;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAvCd;AA2CU;EACE,cAAA;AAzCZ;AA4CU;EACE,yBAAA;EACA,uBAAA;AA1CZ;AA6CU;EACE,yBAAA;EACA,4BAAA;AA3CZ;AA8CU;EACE,sBAAA;EACA,wBAAA;AA5CZ;;AAoDA;EACE,kBAAA;AAjDF;AAmDE;EACE,6BAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AAjDJ;AAmDI;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;AAjDN;;AAwDI;EADF;IAEI,sBAAA;EApDJ;AACF;AAiDE;EAIE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,0CAAA;AAlDJ;AAoDI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+FAAA;EACA,UAAA;EACA,6BAAA;AAlDN;AAqDI;EACE,2BAAA;EACA,+CAAA;AAnDN;AAqDM;EACE,UAAA;AAnDR;AAuDI;EACE,kBAAA;EACA,UAAA;AArDN;AAwDI;EACE,kBAAA;EACA,UAAA;AAtDN;AAyDI;EACE,gCAAA;EACA,yBAAA;EACA,yCAAA;AAvDN;AA0DI;EACE,mCAAA;EACA,0CAAA;AAxDN;;AA6DA;EACE,6DAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,gBAAA;EACA,mCAAA;AA1DJ;AA4DI;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AA1DN;AA6DI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA3DN;AA+DE;EACE,oBAAA;AA7DJ;AAiEI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,iDAAA;AA/DN;AAkEI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,iDAAA;EACA,eAAA;AAhEN;AAkEM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6FAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AAhER;AAmEM;EACE,wCAAA;EACA,8CAAA;AAjER;AAmEQ;EACE,UAAA;AAjEV;AAoEQ;EACE,qBAAA;AAlEV;AAqEQ;EACE,YAAA;AAnEV;AAsEQ;EACE,wBAAA;EACA,UAAA;AApEV;AAwEM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oGAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;AAtER;AAyEM;EACE,aAAA;EACA,UAAA;EACA,2BAAA;EACA,YAAA;EACA,yBAAA;AAvER;AAyEQ;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,gFAAA;EACA,UAAA;EACA,6BAAA;AAvEV;AA0EQ;EACE,UAAA;AAxEV;AA2EQ;EACE,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,oCAAA;AAzEV;AA4EQ;EACE,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,oCAAA;AA1EV;AA6EQ;EACE,6DAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AA3EV;AA6EU;EACE,0BAAA;EACA,6CAAA;EACA,sCAAA;AA3EZ;AA6EY;EACE,0BAAA;AA3Ed;AA+EU;EACE,+BAAA;AA7EZ;AAmFI;EACE,oBAAA;EACA,iBAAA;AAjFN;AAoFI;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;AAlFN;AAoFM;EACE,UAAA;EACA,mBAAA;EACA,UAAA;AAlFR;AAqFM;EAEE,YAAA;EACA,sBAAA;AApFR;AAwFI;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;AAtFN;AAwFM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AAtFR;AAwFQ;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAtFV;AA4FE;EACE;IACE,UAAA;IACA,4BAAA;EA1FJ;EA4FE;IACE,UAAA;IACA,wBAAA;EA1FJ;AACF;AA6FE;EACE,SAAA;EACA,WAAA;AA3FJ;AA6FI;EACE,kBAAA;EACA,gBAAA;AA3FN;;AAgGA;EACE,6DAAA;EACA,kBAAA;AA7FF;AA+FE;EACE,gBAAA;EACA,mCAAA;AA7FJ;AA+FI;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,eAAA;AA7FN;AAgGI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA9FN;AAiGI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA/FN;AAmGE;EACE,SAAA;AAjGJ;AAoGE;EACE,oBAAA;AAlGJ;AAqGE;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;AAnGJ;AAqGI;EACE,2BAAA;AAnGN;AAsGI;EACE,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mEAAA;AApGN;AAsGM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,4BAAA;AApGR;AAuGM;EACE,8CAAA;EACA,2BAAA;AArGR;AAwGM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAtGR;AAyGM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,UAAA;EACA,wCAAA;AAvGR;AA0GM;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAxGR;AA2GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,6FAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAzGR;AA2GQ;EACE,iBAAA;AAzGV;AA4GQ;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA1GV;AA8GM;EACE,SAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,oDAAA;AA7GR;AA+GQ;EACE,UAAA;AA7GV;AAgHQ;EACE,mCAAA;EACA,kBAAA;AA9GV;AAkHM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAhHR;AAmHM;EACE,kBAAA;AAjHR;AAmHQ;;EAEE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAjHV;AAwHE;EACE;IACE,wBAAA;EAtHJ;EAwHE;IACE,4BAAA;EAtHJ;AACF;AAyHE;EACE,mCAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAvHJ;AA0HE;EACE,iBAAA;AAxHJ;;AA4HA;EACE,kBAAA;EACA,0EAAA;EACA,kBAAA;AAzHF;AA2HE;EACE,gBAAA;EACA,mCAAA;AAzHJ;AA2HI;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAzHN;AA4HI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA1HN;AA8HE;;EAEE,mBAAA;AA5HJ;AA8HI;EAJF;;IAKI,mBAAA;EA1HJ;AACF;AA6HE;EAjCF;IAkCI,0BAAA;EA1HF;AACF;AA4HE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mDAAA;EACA,yBAAA;AA1HJ;AA4HI;EACE,uDAAA;AA1HN;AA6HI;EACE,yBAAA;AA3HN;AA8HI;EACE,wBAAA;EACA,4BAAA;AA5HN;AA+HI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,0CAAA;EACA,4DAAA;EACA,yCAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;AA7HN;AA+HM;EACE,mBAAA;EACA,WAAA;EACA,6DAAA;EACA,2CAAA;EACA,eAAA;AA7HR;AAgIM;EACE,mBAAA;EACA,WAAA;EACA,6DAAA;EACA,2CAAA;EACA,kDAAA;AA9HR;AAiIM;EACE,WAAA;EACA,UAAA;AA/HR;AAkIM;EACE,WAAA;EACA,UAAA;AAhIR;AAmIM;EACE,WAAA;EACA,UAAA;AAjIR;AAoIM;EACE,WAAA;EACA,UAAA;AAlIR;AAqIM;EACE,WAAA;EACA,UAAA;AAnIR;AAsIM;EACE,WAAA;EACA,UAAA;AApIR;AAuIM;EACE,WAAA;EACA,UAAA;AArIR;AAwIM;EACE,UAAA;EACA,UAAA;AAtIR;AAyIM;EACE,WAAA;EACA,UAAA;AAvIR;AA0IM;EACE,WAAA;EACA,UAAA;AAxIR;AA2IM;EACE,WAAA;EACA,UAAA;AAzIR;AA4IM;EACE,WAAA;EACA,UAAA;AA1IR;AA6IM;EACE,WAAA;EACA,UAAA;AA3IR;AA8IM;EACE,WAAA;EACA,UAAA;AA5IR;AA+IM;EACE,WAAA;EACA,UAAA;AA7IR;AAgJM;EACE,WAAA;EACA,UAAA;AA9IR;AAmJE;EACE,mBAAA;EACA,6BAAA;AAjJJ;AAmJI;EACE,6BAAA;AAjJN;AAmJM;;EAEE,4BAAA;EACA,6BAAA;AAjJR;AAqJI;;EAEE,mBAAA;EACA,iCAAA;AAnJN;AAuJE;EACE;IACE,mBAAA;IACA,UAAA;EArJJ;EAuJE;IACE,qBAAA;IACA,YAAA;EArJJ;AACF;AAwJE;EACE;IACE,2CAAA;EAtJJ;EAwJE;IACE,qCAAA;EAtJJ;AACF;AAyJE;EACE,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAvJJ;AAyJI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,4BAAA;AAvJN;AA0JI;EACE,8CAAA;EACA,2BAAA;AAxJN;AA2JI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,6FAAA;EACA,mBAAA;EACA,kBAAA;AAzJN;AA2JM;EACE,eAAA;AAzJR;AA4JM;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1JR;AA8JI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,2CAAA;EACA,yBAAA;AA5JN;AA8JM;EACE,mBAAA;AA5JR;AA+JM;EACE,kBAAA;EACA,mCAAA;EACA,mBAAA;AA7JR;AAgKM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AA9JR;AAiKM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA/JR;AAmKI;EACE,UAAA;EACA,4BAAA;AAjKN;AAmKM;;EAEE,UAAA;AAjKR;;AAuKA;EACE,kBAAA;AApKF;AAsKE;EAHF;IAII,kBAAA;EAnKF;AACF;AAqKE;EACE,iBAAA;AAnKJ;AAsKE;EACE,kBAAA;AApKJ;;AAwKA;EACE,mBAAA;EAEA,sBAAA;AAtKF;AAwKE;EACE,SAAA;EACA,qCAAA;EACA,kBAAA;AAtKJ;AAyKE;EACE,YAAA;EACA,WAAA;AAvKJ;AA0KE;EACE;IACE,wBAAA;EAxKJ;EA0KE;IACE,2BAAA;EAxKJ;AACF","sourcesContent":[".home-page-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  // SectionWrapper.scss\n  .section-wrapper {\n    opacity: 0;\n    transform: translateY(30px);\n    transition: all 0.6s ease-out;\n    will-change: transform, opacity;\n\n    &.animate {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .h3-heading {\n    font-family: \"Alice\", serif;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 70px;\n\n    @media screen and (max-width: 576px) {\n      font-size: 35px;\n    }\n  }\n\n  .hotspot-button {\n    width: 20px;\n    height: 20px;\n    transform: translate(-50%, -50%);\n    border: 2px solid white;\n    cursor: pointer;\n  }\n\n  .home-page-carousel-container {\n    padding-top: 40px;\n    padding-bottom: 40px;\n\n    h1 {\n      font-size: 80px;\n      font-family: \"SF  Pro\", sans-serif;\n      font-weight: bold;\n      font-style: normal;\n      background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      animation: fadeInDown 0.8s ease-out;\n    }\n\n    .banner-tagline-box {\n      max-width: 950px;\n      background: linear-gradient(135deg, rgba(178, 32, 32, 0.95) 0%, rgba(255, 117, 117, 0.9) 100%);\n      border-radius: 20px;\n      padding: 35px 45px;\n      box-shadow: 0 10px 40px rgba(178, 32, 32, 0.3);\n      position: relative;\n      overflow: hidden;\n      animation: slideInUp 0.9s ease-out;\n      transition: all 0.4s ease;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: -50%;\n        right: -50%;\n        width: 200%;\n        height: 200%;\n        background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n        animation: rotate 20s linear infinite;\n      }\n\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 15px 50px rgba(178, 32, 32, 0.4);\n      }\n\n      .tagline-content {\n        position: relative;\n        z-index: 1;\n      }\n\n      .tagline-main {\n        font-size: 1.75rem;\n        font-weight: 700;\n        color: #ffffff;\n        margin-bottom: 12px;\n        line-height: 1.4;\n        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n      }\n\n      .tagline-sub {\n        font-size: 1.125rem;\n        color: rgba(255, 255, 255, 0.95);\n        margin: 0;\n        font-weight: 500;\n        line-height: 1.6;\n      }\n    }\n\n    @keyframes fadeInDown {\n      from {\n        opacity: 0;\n        transform: translateY(-30px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    @keyframes slideInUp {\n      from {\n        opacity: 0;\n        transform: translateY(40px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    @keyframes rotate {\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    .heading-mobile {\n      display: none;\n\n      .banner-tagline-box {\n        padding: 25px 30px;\n\n        .tagline-main {\n          font-size: 1.25rem;\n        }\n\n        .tagline-sub {\n          font-size: 0.95rem;\n        }\n      }\n    }\n\n    @media screen and (max-width: 576px) {\n      h1 {\n        font-size: 40px;\n      }\n\n      .heading-mobile {\n        display: block;\n      }\n\n      .heading {\n        display: none;\n      }\n    }\n\n    .swiper {\n      width: 100%;\n\n      img {\n        max-width: 1400px;\n        max-height: 650px;\n        border-radius: 15px;\n        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n        transition: transform 0.3s ease;\n\n        &:hover {\n          transform: scale(1.02);\n        }\n      }\n    }\n  }\n\n  .home-page-wrapper {\n    width: 100%;\n\n    .text-container {\n      max-width: 798px;\n      margin: auto;\n      margin-top: 62px;\n\n      p {\n        color: #212121;\n        font-family: \"SF  Pro\", sans-serif;\n        font-size: 30px;\n        font-weight: bold;\n        letter-spacing: 0;\n        line-height: 37px;\n        max-width: 604px;\n      }\n\n      span {\n        margin-top: 35px;\n        color: #757575;\n        font-family: \"SF  Pro\", sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        letter-spacing: 0;\n        line-height: 30px;\n      }\n    }\n\n    .card-section {\n      @media screen and (min-width: 576px) {\n        margin-top: 100px;\n      }\n      width: 100%;\n\n      &.our-services-section {\n        // Clear fixed header when using /#services (native + scrollIntoView)\n        scroll-margin-top: 80px;\n\n        @media screen and (min-width: 576px) {\n          padding-bottom: 200px !important;\n        }\n        padding-bottom: 250px;\n        .our-services-section-bg {\n          max-width: 1160px;\n        }\n\n        .services-text-section {\n          background: linear-gradient(135deg, #b22020 0%, #d63636 50%, #ff7575 100%);\n          position: relative;\n          overflow: hidden;\n\n          &::before {\n            content: '';\n            position: absolute;\n            top: -50%;\n            left: -50%;\n            width: 200%;\n            height: 200%;\n            background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n            animation: rotateBackground 25s linear infinite;\n          }\n\n          .container {\n            padding-bottom: 200px;\n            animation: fadeIn 0.8s ease-in;\n            position: relative;\n            z-index: 1;\n          }\n\n          h3 {\n            text-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);\n          }\n\n          p {\n            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n          }\n\n          img {\n            clip-path: polygon(60px 0%, 100% 0%, 100% 100%, 0% 100%);\n            height: 230px;\n            transition: all 0.4s ease;\n            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);\n\n            &:hover {\n              transform: scale(1.03) translateX(-5px);\n              box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);\n            }\n          }\n\n          @media screen and (max-width: 576px) {\n            img {\n              display: none;\n            }\n          }\n        }\n\n        @keyframes rotateBackground {\n          from {\n            transform: rotate(0deg);\n          }\n          to {\n            transform: rotate(360deg);\n          }\n        }\n\n        @keyframes fadeIn {\n          from {\n            opacity: 0;\n            transform: translateY(20px);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0);\n          }\n        }\n\n        .services-cards-section {\n          transform: translateY(-50%);\n        }\n\n        .swiper {\n          padding-bottom: 80px;\n        }\n\n        .navigation {\n          right: 40px;\n        }\n\n        .card {\n          border: none;\n          border-radius: 15px;\n          box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\n          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n          cursor: pointer;\n          overflow: hidden;\n          position: relative;\n\n          &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            height: 4px;\n            background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);\n            transform: scaleX(0);\n            transition: transform 0.4s ease;\n          }\n\n          &:hover {\n            transform: translateY(-12px) scale(1.02);\n            box-shadow: 0px 15px 40px rgba(178, 32, 32, 0.25);\n\n            &::before {\n              transform: scaleX(1);\n            }\n          }\n\n          .card-body {\n            padding: 20px;\n\n            h4 {\n              font-weight: 600;\n              color: #212121;\n              margin-top: 16px;\n              font-size: 1.25rem;\n              line-height: 1.4;\n              transition: color 0.3s ease;\n            }\n          }\n\n          &:hover .card-body h4 {\n            color: #b22020;\n          }\n\n          .card-footer {\n            padding: 0 27px 26px 27px;\n            background: transparent;\n          }\n\n          .service-img {\n            transition: all 0.4s ease;\n            border-radius: 10px 10px 0 0;\n          }\n\n          &:hover .service-img {\n            transform: scale(1.08);\n            filter: brightness(1.05);\n          }\n        }\n      }\n    }\n  }\n}\n\n.swiper-pagination {\n  width: max-content;\n\n  .swiper-pagination-bullet {\n    background-color: var(--grey);\n    width: 5px;\n    height: 5px;\n    transition: all 0.3s;\n\n    &.swiper-pagination-bullet-active {\n      width: 30px;\n      background-color: black;\n      border-radius: 10px;\n    }\n  }\n}\n\nsection.easy-support-container {\n  .container {\n    @media screen and (min-width: 768px) {\n      padding: 50px 0 0 64px;    \n    }\n    border-radius: 25px;\n    transition: all 0.4s ease;\n    position: relative;\n    overflow: hidden;\n    background: linear-gradient(135deg, #fdf8f0 0%, #fff5e6 100%);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(135deg, rgba(178, 32, 32, 0.03) 0%, rgba(255, 117, 117, 0.05) 100%);\n      opacity: 0;\n      transition: opacity 0.4s ease;\n    }\n\n    &:hover {\n      transform: translateY(-6px);\n      box-shadow: 0 12px 35px rgba(178, 32, 32, 0.15);\n\n      &::before {\n        opacity: 1;\n      }\n    }\n\n    h3 {\n      position: relative;\n      z-index: 1;\n    }\n\n    p {\n      position: relative;\n      z-index: 1;\n    }\n\n    .easy-support-banner {\n      border-bottom-right-radius: 25px;\n      transition: all 0.4s ease;\n      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n    }\n\n    &:hover .easy-support-banner {\n      transform: scale(1.03) rotate(1deg);\n      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n    }\n  }\n}\n\nsection.our-stories {\n  background: linear-gradient(180deg, #ffffff 0%, #fdf8f0 100%);\n  position: relative;\n\n  .stories-header-box {\n    max-width: 800px;\n    animation: fadeInDown 0.8s ease-out;\n\n    h2 {\n      background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    }\n\n    .stories-subtitle {\n      font-size: 1.25rem;\n      color: #434343;\n      font-weight: 500;\n      line-height: 1.6;\n    }\n  }\n\n  .navigation {\n    justify-content: end;\n  }\n\n  .stories-wrapper {\n    .story-img {\n      height: 450px;\n      object-fit: cover;\n      border-radius: 20px;\n      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    .img-flash-card-wrapper {\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n      cursor: pointer;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);\n        opacity: 0;\n        transition: opacity 0.4s ease;\n        z-index: 1;\n      }\n\n      &:hover {\n        transform: translateY(-10px) scale(1.02);\n        box-shadow: 0 20px 60px rgba(178, 32, 32, 0.3);\n\n        &::before {\n          opacity: 1;\n        }\n\n        .story-img {\n          transform: scale(1.1);\n        }\n\n        .story-overlay {\n          opacity: 0.8;\n        }\n\n        .story-content {\n          transform: translateY(0);\n          opacity: 1;\n        }\n      }\n\n      .story-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.9) 100%);\n        opacity: 0.6;\n        transition: opacity 0.4s ease;\n        z-index: 2;\n      }\n\n      .story-content {\n        padding: 30px;\n        z-index: 3;\n        transform: translateY(20px);\n        opacity: 0.9;\n        transition: all 0.4s ease;\n\n        .story-gradient-bg {\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 100%;\n          background: linear-gradient(180deg, transparent 0%, rgba(178, 32, 32, 0.8) 100%);\n          opacity: 0;\n          transition: opacity 0.4s ease;\n        }\n\n        &.hovered .story-gradient-bg {\n          opacity: 1;\n        }\n\n        .story-city-name {\n          font-size: 2.5rem;\n          font-weight: 700;\n          text-shadow: 0 3px 15px rgba(0, 0, 0, 0.5);\n          margin-bottom: 10px;\n          animation: slideInLeft 0.6s ease-out;\n        }\n\n        .story-description {\n          font-size: 1.125rem;\n          line-height: 1.6;\n          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n          animation: slideInLeft 0.7s ease-out;\n        }\n\n        .story-explore-btn {\n          background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n          border: 2px solid rgba(255, 255, 255, 0.3);\n          border-radius: 50px;\n          padding: 14px 32px;\n          font-size: 1.125rem;\n          font-weight: 600;\n          display: inline-flex;\n          align-items: center;\n          gap: 10px;\n          transition: all 0.3s ease;\n          box-shadow: 0 5px 20px rgba(178, 32, 32, 0.4);\n          cursor: pointer;\n          width: fit-content;\n          animation: slideInLeft 0.8s ease-out;\n\n          &:hover {\n            transform: translateX(5px);\n            box-shadow: 0 8px 30px rgba(178, 32, 32, 0.6);\n            border-color: rgba(255, 255, 255, 0.6);\n\n            svg {\n              transform: translateX(5px);\n            }\n          }\n\n          svg {\n            transition: transform 0.3s ease;\n          }\n        }\n      }\n    }\n\n    .swiper {\n      padding-bottom: 80px;\n      overflow: visible;\n    }\n\n    .swiper-slide {\n      transition: all 0.4s ease;\n      opacity: 0.85;\n      transform: scale(0.95);\n\n      &.swiper-slide-active {\n        opacity: 1;\n        transform: scale(1);\n        z-index: 2;\n      }\n\n      &.swiper-slide-prev,\n      &.swiper-slide-next {\n        opacity: 0.7;\n        transform: scale(0.92);\n      }\n    }\n\n    .swiper-pagination {\n      width: max-content;\n      margin-left: 50%;\n      transform: translateX(-50%);\n      \n      .swiper-pagination-bullet {\n        background: #b22020;\n        width: 12px;\n        height: 12px;\n        opacity: 0.5;\n        transition: all 0.3s ease;\n\n        &.swiper-pagination-bullet-active {\n          opacity: 1;\n          width: 30px;\n          border-radius: 10px;\n        }\n      }\n    }\n  }\n\n  @keyframes slideInLeft {\n    from {\n      opacity: 0;\n      transform: translateX(-30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  .container div {\n    gap: 20px;\n    width: 100%;\n\n    span {\n      font-size: 1.25rem;\n      font-weight: 700;\n    }\n  }\n}\n\nsection.testimonial {\n  background: linear-gradient(180deg, #fdf8f0 0%, #ffffff 100%);\n  position: relative;\n\n  .testimonial-header-box {\n    max-width: 800px;\n    animation: fadeInDown 0.8s ease-out;\n\n    h2 {\n      background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      font-size: 3rem;\n    }\n\n    .testimonial-subheading {\n      font-size: 2rem;\n      color: #434343;\n      font-weight: 600;\n    }\n\n    .testimonial-subtitle {\n      font-size: 1.25rem;\n      color: #434343;\n      font-weight: 500;\n      line-height: 1.6;\n    }\n  }\n\n  .testimonials-wrapper {\n    gap: 80px;\n  }\n\n  .swiper-wrapper {\n    padding-bottom: 60px;\n  }\n\n  .swiper-slide {\n    min-height: 100%;\n    height: auto;\n    transition: all 0.4s ease;\n\n    &:hover {\n      transform: translateY(-5px);\n    }\n\n    .testimonial-card {\n      background: #ffffff;\n      border-radius: 20px;\n      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n      border: none;\n      overflow: hidden;\n      position: relative;\n      transition: box-shadow 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 5px;\n        background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);\n        border-radius: 20px 20px 0 0;\n      }\n\n      &:hover {\n        box-shadow: 0 15px 50px rgba(178, 32, 32, 0.2);\n        transform: translateY(-6px);\n      }\n\n      &.testimonial-card--fixed {\n        width: 100%;\n        max-width: 400px;\n        height: 420px;\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .quote-icon {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        color: rgba(178, 32, 32, 0.15);\n        z-index: 1;\n        animation: float 3s ease-in-out infinite;\n      }\n\n      .testimonial-card-body.card-body {\n        padding: 30px;\n        position: relative;\n        z-index: 2;\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        min-height: 0;\n        text-align: center;\n        align-items: center;\n      }\n\n      .customer-name-badge {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        flex-shrink: 0;\n        margin-bottom: 8px;\n        padding: 12px 20px;\n        background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);\n        border-radius: 50px;\n        width: fit-content;\n        max-width: 100%;\n\n        .customer-icon {\n          font-size: 1.5rem;\n        }\n\n        .card-title {\n          margin: 0;\n          font-size: 1.125rem;\n          font-weight: 700;\n          color: #212121;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n          text-align: center;\n        }\n      }\n\n      .testimonial-scroll-region {\n        flex: 1;\n        min-height: 0;\n        width: 100%;\n        overflow-x: hidden;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n        padding-right: 4px;\n        margin-right: -4px;\n        text-align: center;\n\n        scrollbar-width: thin;\n        scrollbar-color: rgba(178, 32, 32, 0.45) transparent;\n\n        &::-webkit-scrollbar {\n          width: 6px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: rgba(178, 32, 32, 0.35);\n          border-radius: 6px;\n        }\n      }\n\n      .testimonial-content {\n        font-size: 1rem;\n        line-height: 1.8;\n        color: #434343;\n        text-align: center;\n      }\n\n      .testimonial-content--html {\n        text-align: center;\n\n        ol,\n        ul {\n          display: inline-block;\n          text-align: left;\n          margin-left: auto;\n          margin-right: auto;\n        }\n      }\n\n    }\n  }\n\n  @keyframes float {\n    0%, 100% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(-10px);\n    }\n  }\n\n  .line {\n    background-color: var(--grey-light);\n    height: 2px;\n    width: 80%;\n    margin-top: 30px;\n  }\n\n  .adjusted-margin {\n    margin-top: -1rem;\n  }\n}\n\nsection.gst-details-section {\n  padding: 80px 40px;\n  background: linear-gradient(180deg, #ffffff 0%, #fdf8f0 50%, #ffffff 100%);\n  position: relative;\n\n  .gst-header-box {\n    max-width: 900px;\n    animation: fadeInDown 0.8s ease-out;\n\n    h2 {\n      background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    }\n\n    .gst-subtitle {\n      font-size: 1.25rem;\n      color: #434343;\n      font-weight: 500;\n      line-height: 1.6;\n    }\n  }\n\n  h2,\n  .map-hotspots {\n    margin-bottom: 40px;\n\n    @media screen and (min-width: 992px) {\n      margin-bottom: 80px;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 40px 0 !important;\n  }\n\n  .map-hotspots {\n    min-width: 620px;\n    max-width: 620px;\n    height: 720px;\n    position: relative;\n    filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.1));\n    transition: all 0.4s ease;\n\n    &:hover {\n      filter: drop-shadow(0 15px 40px rgba(178, 32, 32, 0.2));\n    }\n\n    path {\n      transition: all 0.3s ease;\n    }\n\n    img {\n      background-size: contain;\n      background-repeat: no-repeat;\n    }\n\n    .state {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #b22020 0%, #ff7575 100%);\n      border: 4px solid rgba(255, 255, 255, 0.9);\n      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n      outline: 2px solid rgba(178, 32, 32, 0.3);\n      box-sizing: content-box;\n      cursor: pointer;\n      animation: pulse 2s ease-in-out infinite;\n\n      &:hover {\n        transform: scale(2);\n        z-index: 10;\n        background: linear-gradient(135deg, #ff7575 0%, #b22020 100%);\n        box-shadow: 0 0 20px rgba(178, 32, 32, 0.6);\n        animation: none;\n      }\n\n      &.selected {\n        transform: scale(2);\n        z-index: 10;\n        background: linear-gradient(135deg, #ff7575 0%, #b22020 100%);\n        box-shadow: 0 0 25px rgba(178, 32, 32, 0.8);\n        animation: selectedPulse 1.5s ease-in-out infinite;\n      }\n\n      &.Goa {\n        left: 128px;\n        top: 540px;\n      }\n\n      &.Uttar.Pradesh {\n        left: 270px;\n        top: 280px;\n      }\n\n      &.Haryana {\n        left: 188px;\n        top: 230px;\n      }\n\n      &.Karnataka {\n        left: 170px;\n        top: 560px;\n      }\n\n      &.Maharashtra {\n        left: 170px;\n        top: 450px;\n      }\n\n      &.Telangana {\n        left: 244px;\n        top: 482px;\n      }\n\n      &.Bihar {\n        left: 380px;\n        top: 305px;\n      }\n\n      &.Gujarat {\n        left: 80px;\n        top: 370px;\n      }\n\n      &.Kerala {\n        left: 180px;\n        top: 644px;\n      }\n\n      &.Himachal.Pradesh {\n        left: 205px;\n        top: 165px;\n      }\n\n      &.Tamil.Nadu {\n        left: 229px;\n        top: 634px;\n      }\n\n      &.Jharkhand {\n        left: 364px;\n        top: 353px;\n      }\n\n      &.Rajasthan {\n        left: 130px;\n        top: 285px;\n      }\n\n      &.Madhya.Pradesh {\n        left: 230px;\n        top: 365px;\n      }\n\n      &.Odisha {\n        left: 360px;\n        top: 420px;\n      }\n\n      &.Chandigarh {\n        left: 183px;\n        top: 200px;\n      }\n    }\n  }\n\n  .accordion-item {\n    border-radius: 30px;\n    border: 1px solid transparent;\n\n    &:has(.accordion-collapse.show) {\n      border: 1px solid var(--grey);\n\n      .accordion-button,\n      .accordion-header {\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n\n    .accordion-header,\n    .accordion-button {\n      border-radius: 30px;\n      background: var(--primary-yellow);\n    }\n  }\n\n  @keyframes pulse {\n    0%, 100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    50% {\n      transform: scale(1.1);\n      opacity: 0.8;\n    }\n  }\n\n  @keyframes selectedPulse {\n    0%, 100% {\n      box-shadow: 0 0 25px rgba(178, 32, 32, 0.8);\n    }\n    50% {\n      box-shadow: 0 0 35px rgba(178, 32, 32, 1);\n    }\n  }\n\n  .state-data-container {\n    background: linear-gradient(135deg, #ffffff 0%, #fdf8f0 100%);\n    border-radius: 25px;\n    padding: 40px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n    min-width: 400px;\n    width: max-content;\n    height: max-content;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.5s ease;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 6px;\n      background: linear-gradient(90deg, #b22020 0%, #ff7575 100%);\n      border-radius: 25px 25px 0 0;\n    }\n\n    &:hover {\n      box-shadow: 0 15px 50px rgba(178, 32, 32, 0.2);\n      transform: translateY(-5px);\n    }\n\n    .state-badge {\n      display: flex;\n      align-items: center;\n      gap: 15px;\n      margin-bottom: 30px;\n      padding: 15px 25px;\n      background: linear-gradient(135deg, rgba(178, 32, 32, 0.1) 0%, rgba(255, 117, 117, 0.1) 100%);\n      border-radius: 50px;\n      width: fit-content;\n\n      .location-icon {\n        font-size: 2rem;\n      }\n\n      .state-name {\n        margin: 0;\n        font-size: 1.75rem;\n        font-weight: 700;\n        color: #212121;\n      }\n    }\n\n    .gst-info-item {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      padding: 15px 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n      transition: all 0.3s ease;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      &:hover {\n        padding-left: 10px;\n        background: rgba(178, 32, 32, 0.05);\n        border-radius: 10px;\n      }\n\n      .info-label {\n        font-size: 0.875rem;\n        font-weight: 600;\n        color: #b22020;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n\n      .info-value {\n        font-size: 1.125rem;\n        font-weight: 500;\n        color: #212121;\n        line-height: 1.6;\n      }\n    }\n\n    &.op-anim {\n      opacity: 0;\n      transform: translateX(-20px);\n\n      p,\n      h3 {\n        opacity: 0;\n      }\n    }\n  }\n}\n\nsection.home-page-content-section {\n  padding: 60px 80px;\n\n  @media screen and (max-width: 768px) {\n    padding: 30px 15px;\n  }\n\n  .font-medium {\n    font-size: 1.5rem;\n  }\n\n  .font-bold {\n    font-size: 2.25rem;\n  }\n}\n\nsection.brand-carousel {\n  white-space: nowrap;\n\n  padding: 40px 0 80px 0;\n\n  .carousel-track {\n    gap: 40px;\n    animation: scroll 15s linear infinite;\n    width: fit-content;\n  }\n\n  .brand-logo {\n    height: 70px;\n    width: auto;\n  }\n\n  @keyframes scroll {\n    from {\n      transform: translateX(0);\n    }\n    to {\n      transform: translateX(-50%);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
